module.exports = __webpack_public_path__ + "img/xbox.f8de46f9.png";